import type { RatingProps as MuiRatingProps } from '@mui/material/Rating';

import MuiRating from '@mui/material/Rating';
import React from 'react';

export interface RatingProps extends Omit<MuiRatingProps, 'defaultValue'> {
  // Passed from form control, we omit it to not get HTML errors for this prop since it does not exist on element.
  InputProps?: any;
}
const Rating = React.forwardRef(
  (
    { InputProps: _, ...ratingProps }: RatingProps,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    return <MuiRating {...ratingProps} ref={ref} />;
  },
);

Rating.displayName = 'Rating';

export default Rating;
